// extracted by mini-css-extract-plugin
export default {"loader":"LoadingIcon_loader__1Hth8","bar":"LoadingIcon_bar__QbslN","fade":"LoadingIcon_fade__llTIG"};